import { AuthProvider } from './hooks/useAuth'
import { ErrorBoundary } from './components/shared'
import AppRouter from './router'

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App
